module.exports = __webpack_public_path__ + "assets/images/daily_activity_g.d42d060e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/daily_activity_g.png
// module id = 695
// module chunks = 1